module.exports = __webpack_public_path__ + "static/media/facebook-icon.fa0764b4.svg";